import { userApi } from '../../../apis/userApi';

export default {
  namespaced: true,
  state: {
    users: [],
    currentPage: 1,
    totalPages: 1,
    itemsPerPage: 10,
    loading: false,
    error: null
  },
  mutations: {
    SET_USERS(state, users) {
      state.users = users;
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page;
    },
    SET_TOTAL_PAGES(state, total) {
      state.totalPages = total;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_ERROR(state, error) {
      state.error = error;
    }
  },
  actions: {
    async fetchUsers({ commit }, { page, size, sort, keyword }) {
      commit('SET_LOADING', true);
      try {
        const response = await userApi.getUsers({
          page: page - 1,
          size,
          sort,
          keyword
        });
        if (response.data.code === 'SUCCESS') {
          commit('SET_USERS', response.data.data.content);
          commit('SET_TOTAL_PAGES', Math.ceil(response.data.data.totalElements / size));
          commit('SET_CURRENT_PAGE', page);
        }
      } catch (error) {
        commit('SET_ERROR', error.message);
        console.error('Error fetching users:', error);
      } finally {
        commit('SET_LOADING', false);
      }
    },
    async createUser({ dispatch }, userData) {
      try {
        const response = await userApi.createUser(userData);
        if (response.data.code === 'SUCCESS') {
          dispatch('fetchUsers', {
            page: 1,
            size: 10,
            sort: 'seq,desc'
          });
          return response.data.data;
        }
      } catch (error) {
        console.error('Error creating user:', error);
        throw error;
      }
    },
    async updateUser({ dispatch }, { userId, userData }) {
      try {
        const response = await userApi.updateUser(userId, userData);
        if (response.data.code === 'SUCCESS') {
          dispatch('fetchUsers', {
            page: 1,
            size: 10,
            sort: 'seq,desc'
          });
          return response.data.data;
        }
      } catch (error) {
        console.error('Error updating user:', error);
        throw error;
      }
    },
    async deleteUser({ dispatch }, userId) {
      try {
        const response = await userApi.deleteUser(userId);
        if (response.data.code === 'SUCCESS') {
          dispatch('fetchUsers', {
            page: 1,
            size: 10,
            sort: 'seq,desc'
          });
        }
      } catch (error) {
        console.error('Error deleting user:', error);
        throw error;
      }
    },
    async changePassword(_, { userId, passwordData }) {
      try {
        const response = await userApi.changePassword(userId, passwordData);
        if (response.data.code === 'SUCCESS') {
          return true;
        }
      } catch (error) {
        console.error('Error changing password:', error);
        throw error;
      }
    }
  },
  getters: {
    getUsers: state => state.users,
    getCurrentPage: state => state.currentPage,
    getTotalPages: state => state.totalPages,
    isLoading: state => state.loading,
    getError: state => state.error
  }
};
